/**
 * NomiContents.js
 */


class NomiContents {

    constructor(lotoCateg, nomiCateg, valArray, lotoBase=null) {
        this.lotoCateg = lotoCateg;
        this.nomiCateg = nomiCateg;
        this.valArray = valArray;
        if(lotoBase) {
            this.setBooArray(lotoBase);
        };
        this.percent = LotoBase.getNomiContensPercent( lotoCateg, nomiCateg, valArray );

    };


    get percentFormat() {   return (this.percent*100).toFixed(2);   }


    setBooArray(lotoBase) {
        this.booArray = lotoBase.makeBooArray( this );
        return this.booArray;
    };


    getBooArraySliceRate(rate) {
        if(!! this.rateSliceBooArray) {
            return this.rateSliceBooArray;
        }else {
            this.rateSliceBooArray = this.booArray.slice( this.booArray.length-rate );
            return this.rateSliceBooArray;
        };
    };

    /**
     * this.booArrayの要素の true の数を、interval間隔でカウントし、配列に格納し返す
	 * 最後尾から(interval*rateCount)回 さかのぼった要素を始点に最後尾までをカウント
     * @param {*} interval 
     * @param {*} rateCount 
     */
    getIntervalCountRate(interval,rateCount) {
        return MyUtility.booArrayIntervalCountRate( this.booArray, interval, rateCount);
    };
    /**
     * 移動平均グラフdataを取得
     * @param {*} movingAvType 
     * @param {*} range 
     * @param {*} rate 
     */
    getMovingAverage( movingAvType, range, rate ) {
        return BooArrayController.makeMovingAverage( movingAvType, this.booArray, range, rate );
    };



    toString() {
        let valStr = "";
        let booStr = "";
        if(this.valArray) {
            this.valArray.forEach( (val, ind, arr) => valStr += ind<arr.length-1 ? val+", ": val );
        }
        if(this.booArray) {
            this.booArray.filter( ( val, ind, arr ) => ind >= arr.length-10  )
                            .map( val => val = val ? 1 : 0 )
                            .forEach( (val, ind, arr) => booStr += ind<arr.length-1 ? val+", ": val  );
        }
        return "lotoC: "+this.lotoCateg.name+" /  nomiC: "+this.nomiCateg.name+" /  valArray: "+valStr+" /  boo: "+booStr;
    };

    


};